import React from "react";

const AddCommentSvg = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.1075 1.73614e-06C17.7783 -0.00309415 22.7407 4.13455 23.779 9.83563C24.2772 12.5662 23.8625 15.1605 22.5782 17.6156C22.4854 17.7936 22.4637 17.9437 22.5256 18.1403C23.0099 19.6883 23.4819 21.2393 23.9538 22.7904C24.124 23.3538 23.8099 23.8878 23.2389 23.9699C23.0563 23.9962 22.8474 23.9467 22.671 23.877C21.3109 23.3414 19.957 22.7965 18.603 22.2455C18.439 22.1789 18.3152 22.1836 18.1589 22.2764C13.5632 24.9931 7.93388 24.4683 3.9726 20.9142C1.62833 18.8121 0.300688 16.1605 0.0422769 13.0151C-0.369324 7.98893 2.25038 3.40393 6.7718 1.19037C8.41665 0.385439 10.1636 0.00309762 11.1075 1.73614e-06ZM21.7952 21.6789C21.7581 21.5474 21.7364 21.4638 21.7117 21.3817C21.3976 20.3322 21.0974 19.2781 20.7616 18.2348C20.6301 17.8261 20.678 17.4856 20.89 17.1171C22.148 14.9175 22.5473 12.5616 22.1001 10.0709C21.0664 4.31257 15.3288 0.535589 9.62051 1.84205C4.20625 3.08195 0.733952 8.3109 1.69951 13.7736C2.5614 18.6527 6.77025 22.2517 11.7218 22.3306C13.8974 22.3647 15.8951 21.7687 17.7024 20.5551C18.0289 20.3353 18.3492 20.2997 18.7113 20.4514C19.2854 20.6929 19.8672 20.9173 20.4475 21.148C20.8823 21.3183 21.3186 21.4901 21.7952 21.6789Z"
        fill="black"
      />
      <path
        d="M7.70641 12.0027C7.70641 12.9485 6.93272 13.7178 5.98573 13.7147C5.04028 13.7116 4.27433 12.9346 4.28052 11.9857C4.28671 11.0523 5.05421 10.2891 5.98882 10.2876C6.93582 10.2861 7.70641 11.0554 7.70641 12.0027Z"
        fill="black"
      />
      <path
        d="M11.9957 13.7148C11.0503 13.7163 10.2781 12.9439 10.2797 11.9981C10.2812 11.0523 11.0549 10.283 12.0019 10.2876C12.9365 10.2923 13.7009 11.0554 13.7055 11.9904C13.7086 12.9377 12.9411 13.7132 11.9957 13.7148Z"
        fill="black"
      />
      <path
        d="M19.7032 12.0043C19.7016 12.9501 18.9279 13.7194 17.9809 13.7148C17.0355 13.7101 16.2711 12.9331 16.2773 11.9857C16.2835 11.0523 17.051 10.2907 17.9856 10.2892C18.9326 10.2861 19.7032 11.057 19.7032 12.0043Z"
        fill="black"
      />
    </svg>
  );
};

export default AddCommentSvg;
